/**
 * CSV生成・ダウンロードの汎用ユーティリティ
 */

/**
 * CSVの1セルをエスケープする。
 * カンマ・改行・ダブルクォートを含む場合は "" で囲み、内部の " は "" にエスケープする。
 * @param {*} value セル値（null/undefinedは空文字に変換）
 * @returns {string}
 */
export const escapeCsvCell = value => {
  const str = value === null || value === undefined ? '' : String(value)
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }

  return str
}

/**
 * ヘッダーと行データからCSV文字列を生成する（BOMなし）。
 * @param {Array<string>} headers ヘッダー行
 * @param {Array<Array<*>>} rows データ行（各行はセル値の配列）
 * @returns {string} CRLF区切りのCSV文字列
 */
export const buildCsv = (headers, rows) => [headers, ...rows]
  .map(cells => cells.map(escapeCsvCell).join(','))
  .join('\r\n')

/**
 * ヘッダーと行データからCSVを生成し、ブラウザでダウンロードする。
 * ExcelでのUTF-8文字化けを防ぐためBOM(\uFEFF)を付与する。
 * @param {Object} params
 * @param {Array<string>} params.headers ヘッダー行
 * @param {Array<Array<*>>} params.rows データ行
 * @param {string} params.fileName ダウンロードファイル名（.csv 拡張子含む）
 */
export const downloadCsv = ({ headers, rows, fileName }) => {
  const csv = buildCsv(headers, rows)
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
